import React from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { useSelector } from 'react-redux';

export default (props) => {

    const eventName = useSelector(state => state.redirect.eventName);
  return (
    <div className='page create-schedule finish-page'>
          <h3 className='page-title'><DateRangeIcon />
              <div>Your appointment, <b>{eventName}</b>, was canceled. Check your email inbox for updates.</div>

              {
              //Event was canceled. Check your email inbox to get updates
              }
      </h3>
    </div>
  )
};